import axios from './index';

// 接口管理
var portAPI = {

   //首页banner
   getColumnBanner(data) {
      return axios.post(`/qswl/rest/columnBanner/findList`, { ...data });
  },

  //企业 活动列表分页数据
  getentActivity(data,page,pageCount) {
    return axios.post(`/qswl/rest/entActivity/findListByPage?page=${page}&pageCount=${pageCount}`, { ...data });
  },
  //企业 场所列表分页数据
  getentPlace(data,page,pageCount) {
    return axios.post(`/qswl/rest/entPlace/findListByPage?page=${page}&pageCount=${pageCount}`, { ...data });
  },

  // 企业 视频列表分页数据
  getentVoid(data,page,pageCount) {
    return axios.post(`/qswl/rest/entVoid/findListByPage?page=${page}&pageCount=${pageCount}`, { ...data });
  },

 //企业 资讯列表分页数据
  getentInform(data,page,pageCount) {
    return axios.post(`/qswl/rest/entInform/findListByPage?page=${page}&pageCount=${pageCount}`, { ...data });
  },

 // 查询资源栏目分页数据
 getcolumnContent(data,page,pageCount) {
  return axios.post(`/qswl/rest/columnContent/findListByPage?page=${page}&pageCount=${pageCount}`, { ...data });
 },

  //系统 活动列表分页数据
  getlibActivity(data,page,pageCount) {
    return axios.post(`/qswl/rest/libActivity/findListByPage?page=${page}&pageCount=${pageCount}`, { ...data });
  },
   //系统 场所列表分页数据
   getlibPlace(data,page,pageCount) {
    return axios.post(`/qswl/rest/libPlace/findListByPage?page=${page}&pageCount=${pageCount}`, { ...data });
  },
 //系统 视频列表分页数据
 getlibVoid(data,page,pageCount) {
  return axios.post(`/qswl/rest/libVoid/findListByPage?page=${page}&pageCount=${pageCount}`, { ...data });
},

 //系统 资讯列表分页数据
 getlibInformt(data,page,pageCount) {
  return axios.post(`/qswl/rest/libInformt/findListByPage?page=${page}&pageCount=${pageCount}`, { ...data });
},


 // classify map actclassify 分类Tree查询列表
 get_cTreeList_data(data) {
  return axios.post('/qswl/rest/category/findTreeList', { ...data });
},
 // 分类子集查询列表
 get_cList_data(data,page,pageCount) {
  return axios.post( `/qswl/rest/category/findListByPage?page=${page}&pageCount=${pageCount}`, { ...data });
},




//资讯 id查询数据
getInformConfig(data){
  return axios.get(`/qswl/rest/entInform/findById/${data.id}`, { ...data });
},
// 活动 id查询数据
getActConfig(data){
  return axios.get(`/qswl/rest/entActivity/findById/${data.id}`, { ...data });
},
// 课堂 id查询数据
getVoidConfig(data){
  return axios.get(`/qswl/rest/entVoid/findById/${data.id}`, { ...data });
},
// 场馆 id查询数据
getPlaceConfig(data){
  return axios.get(`/qswl/rest/entPlace/findById/${data.id}`, { ...data });
},

  //页面配置
  getEntPageConfig(data){
    return axios.get(`/qswl/rest/entPageConfig/findById/${data.id}`, { ...data });
  },

  // app 获取单位主题
  get_ent(data) {
    return axios.get(`/qswl/rest/ent/findById/${data.id}`, { params: {...data}});
  },
  //app 根据页面获取页面配置主题
  get_page(data) {
    return axios.get(`/qswl/rest/entPageConfig/findById/${data.id}`, { params: {...data}});
  },
  //app 获取开屏图
   get_loadImg(data) {
    return axios.get(`/qswl/rest/systemConfig/findById/${data.id}`, {...data});
  },
  //home  根据页面id查询页面内容
  get_home(data){
    return axios.get(`/qswl/rest/entPageConfig/findById/${data.id}`, { params: {...data}});
  },
  //common 天气组件
  get_weather(data){
    return axios.get(`/qswl/rest/weather/find/${data.id}`, { params: {...data}});
  },
  //搜索  热词
   get_rotWord_data(data) {
    return axios.post(`/qswl/rest/search-word/findListByPage?page=${data.page}&pageCount=${data.pageCount}`, { ...data });
  },
  //搜索  根据输入内容查询
  get_search(data,type){
    if(type==0){
      return axios.post(`/qswl/rest/libActivity/findListByPage?page=${data.page}&pageCount=${data.pageCount}`, {...data});
    }else if(type==1){
      return axios.post(`/qswl/rest/libPlace/findListByPage?page=${data.page}&pageCount=${data.pageCount}`, {...data});
    }else if(type==2){
      return axios.post(`/qswl/rest/libInformt/findListByPage?page=${data.page}&pageCount=${data.pageCount}`, {...data});
    }else if(type==3){
      return axios.post(`/qswl/rest/libVoid/findListByPage?page=${data.page}&pageCount=${data.pageCount}`, {...data});
    }
  },
  //catalist 根据栏目id请求列表
  get_colidList_data(data) {
    return axios.get(`/qswl/rest/columnContent/findById/${data.catalogid}`, { params: {...data}});
  },
  // 获取配置参数
  findByKey(params) {
    return axios.get(`/qswl/rest/systemConfig/findByKey/${params.key}`, {}, { method: 'get' })
  }
}
export default portAPI;



// WEBPACK FOOTER //
// ./src/api/api.js